module.exports = __webpack_public_path__ + "static/media/background2.8bb5add8.svg";